import * as invoiceStatuses from "../constants/invoiceStatuses";
import * as paymentStatuses from "../constants/paymentStatuses";
import colorsStyles from "../assets/css/colors.scss";

const RGB_HEX = /^#?(?:([\da-f]{3})[\da-f]?|([\da-f]{6})(?:[\da-f]{2})?)$/i;
const hex2RGB = str => {
  const [, short, long] = String(str).match(RGB_HEX) || [];

  if (long) {
    const value = Number.parseInt(long, 16);
    // eslint-disable-next-line no-bitwise
    return [value >> 16, (value >> 8) & 0xff, value & 0xff];
  }
  if (short) {
    // eslint-disable-next-line no-bitwise
    return Array.from(short, s => Number.parseInt(s, 16)).map(n => (n << 4) | n);
  }
  return [];
};

const colorByInvoiceStatus = status => {
  switch (status) {
    case invoiceStatuses.UNPAID:
      return "primary";
    case invoiceStatuses.PENDING:
      return "warning";
    case invoiceStatuses.PAID:
      return "success";
    case invoiceStatuses.EXPIRED:
      return "darkGrey";
    case invoiceStatuses.VOID:
      return "complementary";
    case invoiceStatuses.DRAFT:
    case invoiceStatuses.DELETED:
      return "neutral";
    default:
      return "secondary";
  }
};

const colorByInvoiceStatusForLineChart = status => {
  switch (status) {
    case invoiceStatuses.PAID:
      return "primary";
    case invoiceStatuses.VOID:
      return "complementary";
    default:
      return "success";
  }
};

const colorByPaymentStatus = status => {
  switch (status) {
    case paymentStatuses.EXPIRED:
    case paymentStatuses.CANCELLED:
      return "darkGrey";
    case paymentStatuses.REJECTED:
    case paymentStatuses.ERROR:
      return "danger";
    case paymentStatuses.DISPUTED:
      return "complementary";
    case paymentStatuses.PROCESSING:
    case paymentStatuses.PENDING:
      return "warning";
    case paymentStatuses.INITIATED:
      return "primary";
    case paymentStatuses.SETTLED:
    case paymentStatuses.RECONCILED:
    case paymentStatuses.EXECUTED:
      return "success";
    default:
      return "secondary";
  }
};

const colorByPaymentMode = status => {
  switch (status) {
    case "DIRECT_PAYMENT":
      return "primary";
    case "CASH":
      return "success";
    case "CARDS":
      return "complementary";
    case "MOBILE_MONEY":
      return "darkGrey";
    case "COLLECTED_EXTERNALLY":
      return "pink";
    case "BANK_TRANSFER": // Payment Order
      return "warning";
    case "SC_SFTP":
      return "darkerGrey";
    case "SGCI_SFTP":
      return "salmon";
    default:
      return "violet";
  }
};

const colorByName = colorName => colorsStyles[colorName];

const hex2Rgba = (hex, opacity) => {
  const rgb = hex2RGB(hex);
  return `rgba(${rgb.join(",")}, ${opacity})`;
};

function hexToRgba(hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
function getColorByHex(hex) {
  return getComputedStyle(document.documentElement).getPropertyValue(`--pl-colors-${hex}`);
}

export {
  colorByInvoiceStatus,
  colorByPaymentStatus,
  colorByPaymentMode,
  hex2RGB,
  getColorByHex,
  colorByName,
  hex2Rgba,
  hexToRgba,
  colorByInvoiceStatusForLineChart
};
